export default {
  lang: {
    confirm: {
      title: 'Czy na pewno chcesz go usunąć? Nie można go przywrócić po usunięciu',
      okText: 'Usuń',
      cancelText: 'Anuluj',
    },
  },
};
